<template>
  <section>
    <div class="step-holder container">
      <div class="columns">
        <div class="column is-9 is-offset-1 stepbar-padding">
          <h1 class="title">Yay ✌️</h1>
          <div class="columns">
            <div class="column is-2">
            </div>
            <div class="column is-10">
              <p>We are eager to have a chat and help you with your digital acceleration towards on-demand manufacturing</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  export default {
    name: 'Success',
    props: {
      form: Object
    },
    mounted() {
      this.emitValidate()
    },
    methods: {
      validate() {
        return true
      },
      emitValidate() {
        this.$emit('validated', this.validate())
      }
    }
  }
</script>

<style lang="scss" scoped>
  .title {
    color: #fff;
    font-weight: 800;
    font-size: 40px;
    line-height: 90.5%;
    max-width: 600px;

    @media screen and (min-width: $tablet) {
      font-size: 100px;
    }
  }

  .line {
    margin-top: 14px;
  }

  p {
    font-weight: 500;
    font-size: 16px;
    line-height: 140%;

    @media screen and (min-width: $tablet) {
      font-size: 32px;
    }
  }
</style>
